import React, { useEffect, useState } from 'react';
import { Trophy } from 'lucide-react';
import api from '../lib/api';
import { formatZAR } from '../lib/format';

export default function Winners() {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/winners')
      .then((r) => setWinners(r.data?.winners || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="winners-page" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-3">Winners' Circle</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl font-black">
        <span className="text-gold-gradient">Previous Winners</span>
      </h1>
      <p className="mt-3 text-[#C0C0C0]">Real people. Real Fridays. Real Golden Catches.</p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="card-embossed p-6 h-40 animate-pulse" />
          ))}
        {!loading &&
          winners.map((w) => (
            <div key={w.id} data-testid={`winner-${w.id}`} className="card-embossed p-6">
              <div className="flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#FFD700] flex items-center justify-center text-black">
                  <Trophy size={20} />
                </div>
                <div>
                  <p className="font-serif-display text-lg text-white font-bold">{w.name}</p>
                  <p className="text-xs text-[#C0C0C0]/70">
                    Draw · {new Date(w.draw_date).toDateString()}
                  </p>
                </div>
              </div>
              <p className="mt-5 text-3xl font-serif-display text-gold-gradient font-black">
                {formatZAR(w.amount)}
              </p>
              <p className="text-sm text-[#C0C0C0]/70 mt-1">Held {w.ticket_count} tickets</p>
            </div>
          ))}
        {!loading && winners.length === 0 && (
          <p className="text-[#C0C0C0]">No winners yet — you could be the first.</p>
        )}
      </div>
    </div>
  );
}
